// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExportOutlinedSvg from "@ant-design/icons-svg/es/asn/ExportOutlined";
import AntdIcon from '../components/AntdIcon';

var ExportOutlined = function ExportOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExportOutlinedSvg
  }));
};

ExportOutlined.displayName = 'ExportOutlined';
export default React.forwardRef(ExportOutlined);